import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgBuildingFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 4.002a2 2 0 0 0-2.752-1.853l-10 3.545A2 2 0 0 0 3 7.547v12.455a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2v-9a2 2 0 0 0-2-2h-2v-5Zm2 16h-2v-9h2v9Zm-12-11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Zm-1 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z", fill: color }));
};
export default factorySvgIcon(SvgBuildingFilled);
//# sourceMappingURL=SvgBuildingFilled.js.map